module.exports = __webpack_public_path__ + "static/media/SPHA2_EDITSINGLE.44f7b01b.mp4";